<script lang="ts">
  import { writable } from "svelte/store";

  import Icon, { type IconName } from "../icons/Icon.svelte";
  import ArrowTooltip from "../tooltips/ArrowTooltip.svelte";
  import TextNew from "../TextNew.svelte";
  import type { PositionOptions } from "../../actions/popover";

  export let name: IconName;
  export let highlighted: boolean = false;
  export let tooltip: { title: string; options: PositionOptions } | undefined = undefined;

  let tooltipOpen = false;

  const anchorElement = writable<HTMLElement | null>(null);

  function onHover() {
    if (!tooltip) return;
    tooltipOpen = true;
  }

  function onLeave() {
    if (!tooltip) return;
    tooltipOpen = false;
  }
</script>

<button
  on:click
  class:highlighted
  bind:this={$anchorElement}
  on:mouseenter={onHover}
  on:mouseleave={onLeave}
>
  <Icon {name} --w="32px" --h="32px" />
</button>
{#if tooltip}
  <ArrowTooltip open={tooltipOpen} {anchorElement} options={tooltip.options}>
    <TextNew size="xs" --rk-text-color="var(--rk-text-light)">{tooltip.title}</TextNew>
  </ArrowTooltip>
{/if}

<style>
  button {
    transition: all 0.15s cubic-bezier(0.65, 0, 0.35, 1);
    color: var(--rekki-neutral-02);
    /* z-index: 999999; */
  }

  button.highlighted {
    color: var(--rekki-dark);
  }

  button:hover {
    color: var(--rekki-dark);
  }
</style>
